import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TAPIStatus } from '@monorepo/types';
import { UnifiedLoginService } from './unified-login/unified-login.service';

export type TUploadResponseDTO = {
  totalProcessedRows: number;
  successfulRows: number;
  failedRows: number;
  errors: number;
  errorFileKeyOpt?: string;
  errorFileKey?: string;
  errorMessageOpt?: string;
};

export type TUploadPdfResponseDTO = {
  status: TAPIStatus;
  errMsg?: string;
};

@Injectable({
  providedIn: 'root',
})
export class UploadDownLoadFileService {
  constructor(private http: HttpClient, private unifiedLoginService: UnifiedLoginService) {}

  downloadSampleTemplate(url: string, payload: any = null) {
    return this.http.post(url, payload, { responseType: 'blob' });
  }

  downloadFileViaGet(url: string) {
    return this.http.get(url, { responseType: 'blob' });
  }

  downloadSampleTemplateWithObserveResponse(url: string, payload: any = null, templateKey: string = '') {
    if (templateKey === 'GENERAL_ISSUES_TEMPLATE') {
      const { factoryId } = this.unifiedLoginService.getUserInfo();
      url = url.replace(':factoryId', factoryId);
    }
    return this.http.post(url, payload, { responseType: 'blob', observe: 'response' });
  }

  downloadSampleTemplateWithObserveResponseGET(url: string) {
    return this.http.get(url, { responseType: 'blob', observe: 'response' });
  }

  uploadExcel(url: string, formData: FormData) {
    return this.http.post<TUploadResponseDTO>(url, formData);
  }

  downloadErrorTemplate(url: string) {
    return this.http.post(url, null, { responseType: 'blob' });
  }

  downloadSampleTemplatePlani8(url: string, payload?: object) {
    if (payload) return this.http.post(url, payload, { responseType: 'blob' });
    else return this.http.get(url, { responseType: 'blob' });
  }

  downloadErrorTemplatePlani8(url: string) {
    return this.http.get(url, { responseType: 'blob' });
  }

  downloadErrorTemplateWithObserveResponse(url: string) {
    return this.http.post(url, null, { responseType: 'blob', observe: 'response' });
  }

  uploadPdfFile(url: string, formData: FormData) {
    return this.http.post<TUploadPdfResponseDTO>(url, formData);
  }

  downloadPdfFileForViewing(url: string) {
    return this.http.get(url, { responseType: 'blob' });
  }
}
